// componentes
import FormCompetitions from '@/components/contractor/competitions/new/IndexForm.vue';
import InviteSuppliersModal from '@/components/modal/invite-suppliers-modal';
// Constantes
import { USER_TYPE } from '@/utils/constants';
import { showErrorModalByStatus } from '@/utils';
// modulos
import { mapGetters } from 'vuex';
import moment from 'moment';
// Requesições
import { saveDrafts, createQuotation } from '@/services';
export default {
    name: 'NewCompetitions',
    components: { FormCompetitions, InviteSuppliersModal },
    data: () => ({
        inviteSuppliersModal: false,
        USER_TYPE: USER_TYPE,
        modalMessage: '',
        form: {},
        showError: false,
        saveDraftButtonDisabled: false,
        messageError: '',
        invitedSuppliers: {},
        loadingDraft: false,
        loadingNewQuotation: false,
        loading: false
    }),
    methods: {
        ...mapGetters('user', ['userType']),
        showErrorMessage(message) {
            this.messageError = message;
            this.showError = true;
            window.scrollTo(0, 0);
        },
        addSupplier(data) {
            const supplier = {
                disabled: false,
                email: data.email,
                invited_at: moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
                name: data.tradingName,
                phone: data.phone,
                status: 'not visualized',
                token: '',
                website: data.website
            };
            this.invitedSuppliers = supplier;
            this.inviteSuppliersModal = false;
        },
        async saveDrafts({ data, draftId }) {
            this.loadingDraft = true;
            this.saveDraftButtonDisabled = true;
            const response = await saveDrafts(data, draftId);
            if (response) {
                this.$router.push({ name: 'ListCompetitions' });
            } else {
                this.loadingDraft = false;
                this.showErrorMessage(showErrorModalByStatus(response));
            }
            this.saveDraftButtonDisabled = false;
        },
        async createQuotation(data) {
            this.loadingNewQuotation = true;
            const response = await createQuotation(data);
            if (response) {
                this.$router.push({ name: 'ListCompetitions' });
            } else {
                this.loadingNewQuotation = false;
                this.showErrorMessage(showErrorModalByStatus(response));
            }
        }
    },
    computed: {
        pageTitle() {
            return this.$route.name == 'NewCompetition' ? 'Nova cotação' : 'Revisão de solicitação';
        }
    }
};
